import React from 'react';
import type { IconBaseProps } from 'react-icons';
import { FiAlertTriangle } from 'react-icons/fi';

const WarningIcon = (props: IconBaseProps) => {
  return <FiAlertTriangle {...props} />;
};

export default WarningIcon;
